import type { ReactNode } from 'react';

export type PreviewPlatform = 'android' | 'ios';
export type PreviewTheme = 'light' | 'dark';

/**
 * A phone-sized frame for previews (BB-61): the status bar of the platform, the feed width of the VCG app (360 pt) and
 * its light or dark background. Not a device emulation — layout only.
 */
export function PhoneFrame({ platform, theme = 'light', title, children }: { platform: PreviewPlatform; theme?: PreviewTheme; title?: string; children: ReactNode }) {
  return (
    <figure className={`bb-phone bb-phone--${platform} bb-phone--${theme}`} aria-label={`${platform === 'ios' ? 'iOS' : 'Android'} preview${theme === 'dark' ? ', dark theme' : ''}`}>
      <div className="bb-phone__status" aria-hidden="true">
        <span>9:41</span>
        {platform === 'ios' && <span className="bb-phone__notch" />}
        <span>●●●</span>
      </div>
      {title && <div className="bb-phone__title">{title}</div>}
      <div className="bb-phone__screen">{children}</div>
    </figure>
  );
}
